module.exports = __webpack_public_path__ + "static/media/buy-sell.def8b834.jpg";